import Customer from './editors/Customer.json';
import Vendor from './editors/Vendor.json';
import Supplier from './editors/Supplier.json';
import Carrier from './editors/Carrier.json';
import Employee from './editors/Employee.json';
import Warehouse from './editors/Warehouse.json';

import Item from './editors/Item.json';
import ItemSubstitute from './editors/ItemSubstitute.json';
import ItemModifierProfile from './editors/ItemModifierProfile.json';
import ItemModifierGroup from './editors/ItemModifierGroup.json';
import BusinessEntity from './editors/BusinessEntity.json';
import Store from './editors/Store.json';
import ServePlace from './editors/ServePlace.json';
import SaleChannel from './editors/SaleChannel.json';
import SocialChannel from './editors/SocialChannel.json';
import Integration from './editors/Integration.json';
import CarrierService from './editors/CarrierService.json';

import APRequest from './editors/APRequest.json';
import APOrder from './editors/APOrder.json';
import APOrderItem from './editors/APOrderItem.json';
import APShipment from './editors/APShipment.json';
import APDelivery from './editors/APDelivery.json';
import APCredit from './editors/APCredit.json';
import APInvoice from './editors/APInvoice.json';
import APImportCost from './editors/APImportCost.json';
import APQuotation from './editors/APQuotation.json';
import APVendorPromotion from './editors/APVendorPromotion.json';

import ARPriceList from './editors/ARPriceList.json';
import ARPromotion from './editors/ARPromotion.json';
import ARAppointment from './editors/ARAppointment.json';
import ARServicePlan from './editors/ARServicePlan.json';
import AREvent from './editors/AREvent.json';
import ARTravel from './editors/ARTravel.json';
import AROrder from './editors/AROrder.json';
import AROrderItem from './editors/AROrderItem.json';
import ARShipment from './editors/ARShipment.json';
import ARDelivery from './editors/ARDelivery.json';
import ARCredit from './editors/ARCredit.json';
import ARInvoice from './editors/ARInvoice.json';
import ARServeAlwnRule from './editors/ARServeAlwnRule.json';
import ARServeMaterialIssue from './editors/ARServeMaterialIssue.json';
import ARItemStatus from './editors/ARItemStatus.json';

import ServicePack from './editors/ServicePack.json';
import DepositCard from './editors/DepositCard.json';
import DepositPack from './editors/DepositPack.json';

import HRWorkShift from './editors/HRWorkShift.json';
import HRAttendanceSite from './editors/HRAttendanceSite.json';
import HRWorkingSalary from './editors/HRWorkingSalary.json';
import HRAdjust from './editors/HRAdjust.json';
import HRAllowance from './editors/HRAllowance.json';
import HRCommision from './editors/HRCommision.json';
import HROrder from './editors/HROrder.json';
import HRCredit from './editors/HRCredit.json';

import CAAccount from './editors/CAAccount.json';
import CAReceive from './editors/CAReceive.json';
import CAIssue from './editors/CAIssue.json';
import CARequest from './editors/CARequest.json';
import CATransfer from './editors/CATransfer.json';
import MKGCampaign from './editors/MKGCampaign.json';
import CAAdjust from './editors/CAAdjust.json';
import CABankStatement from './editors/CABankStatement.json';

import EXPItem from './editors/EXPItem.json';
import EXPBudget from './editors/EXPBudget.json';
import EXPOrder from './editors/EXPOrder.json';
import EXPCredit from './editors/EXPCredit.json';
import EXPCost from './editors/EXPCost.json';
import EXPInvoice from './editors/EXPInvoice.json';

import EXROrder from './editors/EXROrder.json';
import EXRInvoice from './editors/EXRInvoice.json';

import ICIssue from './editors/ICIssue.json';
import ICReceipt from './editors/ICReceipt.json';
import ICTransfer from './editors/ICTransfer.json';
import ICAdjust from './editors/ICAdjust.json';
import ICCounting from './editors/ICCounting.json';
import ICBOM from './editors/ICBOM.json';
import ICAssemblyOrder from './editors/ICAssemblyOrder.json';

import SPCSourcingPolicy from './editors/SPCSourcingPolicy.json';
import SPCPurchaseByICRule from './editors/SPCPurchaseByICRule.json';
import SPCPurchaseByARRule from './editors/SPCPurchaseByARRule.json';
import SPCDemandBatch from './editors/SPCDemandBatch.json';
import SPCDemandPlanning from './editors/SPCDemandPlanning.json';

import LGOrder from './editors/LGOrder.json';
import LGTransport from './editors/LGTransport.json';

import GLAccount from './editors/GLAccount.json';
import GLCostCenter from './editors/GLCostCenter.json';
import GLJournal from './editors/GLJournal.json';

import PNLCost from './editors/PNLCost.json';
import PNLAccount from './editors/PNLAccount.json';
import PNLJournal from './editors/PNLJournal.json';
import RentalObject from './editors/RentalObject.json';
import ARRentalBooking from './editors/ARRentalBooking.json';

import PMProject from './editors/PMProject.json';
import PMProjectTemplate from './editors/PMProjectTemplate.json';
import PMResource from './editors/PMResource.json';
import PMTask from './editors/PMTask.json';

import ACUserGroup from './editors/ACUserGroup.json';
import ACUserAccount from './editors/ACUserAccount.json';

import Tax from './editors/Tax.json';
import UserProfile from './editors/UserProfile.json';
import Setting from './editors/Setting.json';
import Bank from './editors/Bank.json';

import PMFeature from './editors/PMFeature.json';
import CRMComsRule from './editors/CRMComsRule.json';

import FAAsset from './editors/FAAsset.json';
import FAAssetRegister from './editors/FAAssetRegister.json';
import FAAssetAdjInc from './editors/FAAssetAdjInc.json';
import FAAssetAdjDec from './editors/FAAssetAdjDec.json';
import FAAssetDispose from './editors/FAAssetDispose.json';

import FAEquipment from './editors/FAEquipment.json';
import FAEquipmentRegister from './editors/FAEquipmentRegister.json';
import FAEquipmentDispose from './editors/FAEquipmentDispose.json';

import MFWorkshop from './editors/MFWorkshop.json';
import HRLeaveType from './editors/HRLeaveType.json';
import MFLine from './editors/MFLine.json';
import MFStorage from './editors/MFStorage.json';
import MFProceduce from './editors/MFProceduce.json';
import MFPhase from './editors/MFPhase.json';
import MFRoute from './editors/MFRoute.json';
import MFBOM from './editors/MFBOM.json';

import MFMDSTicket from './editors/MFMDSTicket.json';
import MFMDSSummary from './editors/MFMDSSummary.json';

import MFMakeOrder from './editors/MFMakeOrder.json';
import MFMaterialIssue from './editors/MFMaterialIssue.json';
import POSCashSettlement from './editors/POSCashSettlement.json';

var data = [];

data.push({ name: 'APRequest', value: APRequest });
data.push({ name: 'APOrder', value: APOrder });
data.push({ name: 'APOrderItem', value: APOrderItem });
data.push({ name: 'APShipment', value: APShipment });
data.push({ name: 'APDelivery', value: APDelivery });
data.push({ name: 'APCredit', value: APCredit });
data.push({ name: 'APInvoice', value: APInvoice });
data.push({ name: 'APImportCost', value: APImportCost });

data.push({ name: 'ARPriceList', value: ARPriceList });
data.push({ name: 'ARPromotion', value: ARPromotion });
data.push({ name: 'ARAppointment', value: ARAppointment });
data.push({ name: 'ARServicePlan', value: ARServicePlan });
data.push({ name: 'AREvent', value: AREvent });
data.push({ name: 'ARTravel', value: ARTravel });
data.push({ name: 'AROrder', value: AROrder });
data.push({ name: 'AROrderItem', value: AROrderItem });
data.push({ name: 'ARShipment', value: ARShipment });
data.push({ name: 'ARDelivery', value: ARDelivery });
data.push({ name: 'ARCredit', value: ARCredit });
data.push({ name: 'ARInvoice', value: ARInvoice });
data.push({ name: 'ARServeAlwnRule', value: ARServeAlwnRule });
data.push({ name: 'ARServeMaterialIssue', value: ARServeMaterialIssue });
data.push({ name: 'ARItemStatus', value: ARItemStatus }); // editor ARItemStatus_ChannelMapping (khớp SP thủ công channel + social)

data.push({ name: 'ServicePack', value: ServicePack });
data.push({ name: 'DepositPack', value: DepositPack });
data.push({ name: 'DepositCard', value: DepositCard });

data.push({ name: 'ICReceipt', value: ICReceipt });
data.push({ name: 'ICIssue', value: ICIssue });
data.push({ name: 'ICAdjust', value: ICAdjust });
data.push({ name: 'ICTransfer', value: ICTransfer });
data.push({ name: 'ICCounting', value: ICCounting });
data.push({ name: 'ICBOM', value: ICBOM });
data.push({ name: 'ICAssemblyOrder', value: ICAssemblyOrder });

data.push({ name: 'SPCSourcingPolicy', value: SPCSourcingPolicy });
data.push({ name: 'SPCPurchaseByICRule', value: SPCPurchaseByICRule });
data.push({ name: 'SPCPurchaseByARRule', value: SPCPurchaseByARRule });
data.push({ name: 'SPCDemandBatch', value: SPCDemandBatch });
data.push({ name: 'SPCDemandPlanning_All', value: SPCDemandPlanning });

data.push({ name: 'LGOrder', value: LGOrder });
data.push({ name: 'LGTransport', value: LGTransport });

data.push({ name: 'HRWorkShift', value: HRWorkShift });
data.push({ name: 'HRAttendanceSite', value: HRAttendanceSite });
data.push({ name: 'HRWorkingSalary', value: HRWorkingSalary });
data.push({ name: 'HRAdjust', value: HRAdjust });
data.push({ name: 'HRCommision', value: HRCommision });
data.push({ name: 'HRAllowance', value: HRAllowance });
data.push({ name: 'HROrder', value: HROrder });
data.push({ name: 'HRCredit', value: HRCredit });

data.push({ name: 'CAAccount', value: CAAccount });
data.push({ name: 'CARequest', value: CARequest });
data.push({ name: 'CAIssue', value: CAIssue });
data.push({ name: 'CAReceive', value: CAReceive });
data.push({ name: 'CATransfer', value: CATransfer });
data.push({ name: 'MKGCampaign', value: MKGCampaign });
data.push({ name: 'CAAdjust', value: CAAdjust });
data.push({ name: 'CABankStatement', value: CABankStatement });

data.push({ name: 'Customer', value: Customer });
data.push({ name: 'SaleChannel', value: SaleChannel });
data.push({ name: 'SocialChannel', value: SocialChannel });
data.push({ name: 'Store', value: Store });
data.push({ name: 'ServePlace', value: ServePlace });
data.push({ name: 'Vendor', value: Vendor });
data.push({ name: 'Supplier', value: Supplier });
data.push({ name: 'Carrier', value: Carrier });
data.push({ name: 'Employee', value: Employee });
data.push({ name: 'Warehouse', value: Warehouse });

data.push({ name: 'Item', value: Item });
data.push({ name: 'ItemSubstitute', value: ItemSubstitute });
data.push({ name: 'ItemModifierProfile', value: ItemModifierProfile });
data.push({ name: 'ItemModifierGroup', value: ItemModifierGroup });
data.push({ name: 'BusinessEntity', value: BusinessEntity });
data.push({ name: 'CarrierService', value: CarrierService });

data.push({ name: 'EXPItem', value: EXPItem });
data.push({ name: 'EXPBudget', value: EXPBudget });
data.push({ name: 'EXPOrder', value: EXPOrder });
data.push({ name: 'EXPCredit', value: EXPCredit });
data.push({ name: 'EXPCost', value: EXPCost });
data.push({ name: 'EXPInvoice', value: EXPInvoice });

data.push({ name: 'EXROrder', value: EXROrder });
data.push({ name: 'EXRInvoice', value: EXRInvoice });
// data.push({ name: 'EXPAllocate', value: EXPAllocate });

data.push({ name: 'GLAccount', value: GLAccount });
data.push({ name: 'GLCostCenter', value: GLCostCenter });
data.push({ name: 'GLJournal', value: GLJournal });

data.push({ name: 'PNLAccount', value: PNLAccount });
data.push({ name: 'PNLCost', value: PNLCost });
data.push({ name: 'PNLJournal', value: PNLJournal });
data.push({ name: 'RentalObject', value: RentalObject });
data.push({ name: 'ARRentalBooking', value: ARRentalBooking });

data.push({ name: 'PMProject', value: PMProject });
data.push({ name: 'PMProjectTemplate', value: PMProjectTemplate });
data.push({ name: 'PMResource', value: PMResource });
data.push({ name: 'PMTask', value: PMTask });

data.push({ name: 'ACUserGroup', value: ACUserGroup });
data.push({ name: 'ACUserAccount', value: ACUserAccount });

data.push({ name: 'Tax', value: Tax });
data.push({ name: 'UserProfile', value: UserProfile });
data.push({ name: 'Setting', value: Setting });
data.push({ name: 'Bank', value: Bank });
data.push({ name: 'PMFeature', value: PMFeature });
data.push({ name: 'CRMComsRule', value: CRMComsRule });

data.push({ name: 'FAAsset', value: FAAsset });
data.push({ name: 'FAAssetRegister', value: FAAssetRegister });
data.push({ name: 'FAAssetAdjInc', value: FAAssetAdjInc });
data.push({ name: 'FAAssetAdjDec', value: FAAssetAdjDec });
data.push({ name: 'FAAssetDispose', value: FAAssetDispose });

data.push({ name: 'FAEquipment', value: FAEquipment });
data.push({ name: 'FAEquipmentRegister', value: FAEquipmentRegister });
data.push({ name: 'FAEquipmentDispose', value: FAEquipmentDispose });

data.push({ name: 'MFWorkshop', value: MFWorkshop });
data.push({ name: 'HRLeaveType', value: HRLeaveType });
data.push({ name: 'MFLine', value: MFLine });
data.push({ name: 'MFStorage', value: MFStorage });
data.push({ name: 'MFProceduce', value: MFProceduce });
data.push({ name: 'MFPhase', value: MFPhase });
data.push({ name: 'MFRoute', value: MFRoute });
data.push({ name: 'MFBOM', value: MFBOM });

data.push({ name: 'MFMDSTicket', value: MFMDSTicket });
data.push({ name: 'MFMDSSummary', value: MFMDSSummary });
data.push({ name: 'MFMakeOrder', value: MFMakeOrder });
data.push({ name: 'MFMaterialIssue', value: MFMaterialIssue });
data.push({ name: 'POSCashSettlement', value: POSCashSettlement });

data.push({ name: 'APQuotation', value: APQuotation });
data.push({ name: 'APVendorPromotion', value: APVendorPromotion });

// Integration umbrella (Phase 9B-C) — INTConnection dropdown editors
data.push({ name: 'Integration', value: Integration });

export default data;
